export enum LeftPaneSelectedSection {
  ASSETS = 'assets',
  SEQUENCES = 'sequences',
  MAIN_PROGRAM = 'main-program',
}
